import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "../../firebase.ts";

interface Return {
  createUser: (companyName: string) => Promise<Response>;
}

interface Request {
  companyName: string;
}

interface Response {
  success: boolean;
  message: string;
}

export const useCreateUser = (): Return => {
  return {
    createUser: async (companyName: string) => {
      const functions = getFirebaseFunctions();
      const createUser = httpsCallable<Request, Response, object>(
        functions,
        "createUser",
      );
      const res = await createUser({ companyName });
      return res.data;
    },
  };
};
